import React, { useContext, useEffect, useRef } from 'react';
import { MessageWrapper } from './message.styled';
import ChatLoader from '../../../ChatLoader';
import Forms from '../../Forms';
import useScreenSize from '../../../../../Hooks/DeviceScreenSize';

const Message = ({
	text,
	type,
	scrollId,
	deviceType,
	suggestions,
	submitChat,
	form,
	submitLoader,
	setSubmitLoader,
	allMessages,
	currentIndex,
	setFormIsActive,
	formIsActive,
	isLastMessage,
}) => {
	const screenSize = useScreenSize();
	useEffect(() => {
		let hideInput =
			allMessages[allMessages.length - 1].type === 'server' &&
			allMessages[allMessages.length - 1].form &&
			allMessages[allMessages.length - 1].form.length;
		if (hideInput) {
			setFormIsActive(true);
		} else {
			setFormIsActive(false);
		}
	}, []);
	return (
		<MessageWrapper
			className={`${deviceType} ${type} ${
				text.length < 160 &&
				type === 'server' &&
				text !== 'loading' &&
				deviceType !== 'mobile' &&
				form.length === 0
					? 'change'
					: ''
			} ${form && form.length > 0 && screenSize < 500 ? 'form' : ''}`}
			id={scrollId}
		>
			{type === 'server' ? (
				<>
					{text !== 'loading' ? (
						<div
							className={`server-message-suggestions ${
								text.length < 160 &&
								type === 'server' &&
								deviceType !== 'mobile' &&
								form.length === 0
									? 'change'
									: ''
							}`}
						>
							<div
								className={`server-message ${
									screenSize < 500 ? 'sizeChange' : ''
								} ${form.length > 0 ? 'expand' : ''}`}
							>
								<div className='ai-text-holder'>
									<span
										className={`ff-chatbot-body1`}
										style={{ lineHeight: 2 }}
										dangerouslySetInnerHTML={{ __html: text }}
									></span>
								</div>
								{form.length ? (
									<div>
										<>
											<Forms
												form={form}
												submitChat={submitChat}
												submitLoader={submitLoader}
												setSubmitLoader={setSubmitLoader}
												allMessages={allMessages}
												currentIndex={currentIndex}
												formIsActive={formIsActive}
												isLastMessage={isLastMessage}
											/>
										</>
									</div>
								) : null}
							</div>
							{suggestions &&
								suggestions.map((suggestion) => (
									<div
										className={`suggestions ${
											text.length < 160 &&
											type === 'server' &&
											deviceType !== 'mobile' &&
											form.length === 0
												? 'change'
												: ''
										}`}
									>
										<button
											disabled={!isLastMessage}
											onClick={() => submitChat(suggestion)}
										>
											{suggestion}
										</button>
									</div>
								))}
						</div>
					) : null}
					{text === 'loading' ? (
						<div className='loading'>
							<ChatLoader dotcolor={'#43A1FE'} margin='0' />
						</div>
					) : null}
				</>
			) : (
				<div className='user-message'>
					<div className='user-text-holder'>
						<span
							className='ff-chatbot-body1'
							style={{ lineHeight: 2 }}
							dangerouslySetInnerHTML={{ __html: text }}
						></span>
					</div>
				</div>
			)}
		</MessageWrapper>
	);
};

export default Message;
